import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, ShieldIcon, CreditCardIcon, FileTextIcon, FlagIcon } from 'lucide-react';
export function FinalCTA() {
  const trustBadges = [{
    icon: <LockIcon className="w-4 h-4" data-id="element-58" />,
    text: 'Pago 100% seguro'
  }, {
    icon: <ZapIcon className="w-4 h-4" data-id="element-59" />,
    text: 'Acceso en 5 minutos'
  }, {
    icon: <ShieldIcon className="w-4 h-4" data-id="element-60" />,
    text: 'Garantía 7 días'
  }, {
    icon: <CreditCardIcon className="w-4 h-4" data-id="element-61" />,
    text: 'Mercado Pago · Tarjeta · Transferencia'
  }, {
    icon: <FileTextIcon className="w-4 h-4" data-id="element-62" />,
    text: '100% PDF'
  }, {
    icon: <FlagIcon className="w-4 h-4" data-id="element-63" />,
    text: 'Hecho en Argentina'
  }];
  return <section className="w-full bg-white py-8 md:py-16" data-id="element-64">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-66">
          <div className="max-w-2xl mx-auto mb-6 md:mb-12" data-id="element-67">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-orange-50 border-2 border-orange-400 rounded-lg p-8 relative" data-id="element-68">
              <h4 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-69">
                🍩 MEGA PACK EMPRENDE MINIDONAS 360
              </h4>
              <p className="text-orange-500 font-semibold mb-4" data-id="element-70">
                6 Tomos + 3 Bonos · Masa → Negocio en Pesos
              </p>
              <div className="mb-6" data-id="element-71">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-72">
                  <span className="text-gray-400 line-through text-xl" data-id="element-73">
                    $34.990
                  </span>
                  <span className="text-orange-500 font-bold text-4xl" data-id="element-74">
                    $13.990
                  </span>
                  <span className="text-gray-500" data-id="element-75">ARS</span>
                </div>
              </div>
              <motion.a href="https://www.recursohub.com/cart/48199368966336:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg px-6 py-4 rounded-lg transition-colors shadow-lg shadow-orange-500/20 text-center" data-id="element-76">
                🔴 → QUIERO MI MEGA PACK AHORA
              </motion.a>
            </motion.div>
          </div>

          <div className="flex flex-wrap gap-1.5 md:gap-3 items-center justify-center" data-id="element-77">
            {trustBadges.map((badge, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.3
          }} className="flex items-center gap-1 md:gap-2 bg-orange-50 border border-orange-200 rounded-full px-2 py-1 md:px-4 md:py-2" data-id="element-78">
                <span className="text-orange-500 [&>svg]:w-3 [&>svg]:h-3 md:[&>svg]:w-4 md:[&>svg]:h-4" data-id="element-79">
                  {badge.icon}
                </span>
                <span className="text-[10px] md:text-sm text-gray-600 font-medium leading-tight" data-id="element-80">
                  {badge.text}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}